import { useState } from 'react';

// Tiny click-to-toggle info popover. CJ 2026-06-30 added the PTO
// policy text to the Pay & PTO section so managers can answer the
// "is this for vacation or sick?" question without DM'ing him.
export function PolicyInfoIcon({ text, label }) {
  const [open, setOpen] = useState(false);
  return (
    <span style={{ position: 'relative', display: 'inline-block', textTransform: 'none', letterSpacing: 0, marginLeft: 6 }}>
      <button type="button" onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
        aria-label={label || 'Policy info'}
        title={label || 'Policy info'}
        style={{ width: 16, height: 16, borderRadius: '50%', border: '1px solid #9e9e9e',
                  background: '#fff', color: '#616161', fontSize: 11, lineHeight: '14px',
                  cursor: 'pointer', padding: 0, fontFamily: 'inherit', fontWeight: 700 }}>
        i
      </button>
      {open && (
        <span onClick={() => setOpen(false)}
          style={{ position: 'absolute', top: 22, left: 0, zIndex: 10,
                    background: '#fff', border: '1px solid #d0d4d9', borderRadius: 6,
                    padding: '8px 10px', fontSize: 12, color: '#37474f', lineHeight: 1.4,
                    fontWeight: 400, width: 280,
                    boxShadow: '0 6px 18px rgba(0,0,0,0.08)' }}>
          {text}
        </span>
      )}
    </span>
  );
}
